import { Component, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ComplaintService } from '../../../services/complaint.service';
import { AuthService } from '../../../services/auth.service';

import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { Comments } from 'app/models/complaint.interface';

export interface ComplaintChatData {
  complaintId: number;
  editable:boolean;
  comments:Comments[];
  isDialog:boolean;
}

@Component({
  selector: 'app-complaint-chat',
  templateUrl: './complaint-chat.component.html',
  styleUrls: ['./complaint-chat.component.scss']
})
export class ComplaintChatComponent implements OnInit {
  
  public loading: boolean;
  public userName: string;

  @ViewChild(FusePerfectScrollbarDirective, {static: false})
  directiveScroll: FusePerfectScrollbarDirective;
  
  @Input() complaintId: number;
  @Input() editable: boolean;
  @Input() comments: Comments[];
  isDialog: boolean = false;

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: ComplaintChatData,
    @Optional()
    private dialogRef: MatDialogRef<ComplaintChatComponent>,
    private complaintService: ComplaintService,
    authService: AuthService,
  ) {
    // this.userName = authService.currentUser.userName;
  }

  ngOnInit(): void {

    this.complaintId = this.complaintId ? this.complaintId : this.data.complaintId;
    this.editable = this.editable ? this.editable : this.data ? this.data.editable : false;
    this.comments = this.comments ? this.comments : this.data ? this.data.comments : [];
    this.isDialog = this.data?.isDialog ?? false;

    if (this.dialogRef) {
      this.dialogRef.beforeClosed().subscribe(value => this.dialogRef.close(this.comments));
    }

  }

  addComment(comment: string) {

    if (!this.complaintId && comment) {
      let newComment: Comments = {
        id: 0,
        comment,
        createdBy: null,
        createdDate: new Date()
      }
      this.comments.push(newComment);
    }
    
  }

  deleteMessage(index: number): void {
    this.comments.splice(index, 1);
  }
  
  onDismiss() {
    this.dialogRef.close(this.comments);
  }

}
